const VERTICAL_GAP = 180
const HORIZONTAL_OFFSET = 5
const DEFAULT_SIDEBAR_WIDTH = 260

export function floatingElemPosition(
  targetRect,
  floatingElem,
  anchorElem,
  verticalGap = VERTICAL_GAP,
  paddingTop = 20,
) {
  const sideContainer = document.getElementById("sideContainer")

  const sideContainerRect = sideContainer?.getBoundingClientRect()

  const scrollerElem = anchorElem.parentElement

  if (targetRect === null || !scrollerElem) {
    floatingElem.style.opacity = "0"
    floatingElem.style.transform = "translate(-10000px, -10000px)"
    return
  }
  const floatingElemRect = floatingElem.getBoundingClientRect()
  const anchorElementRect = anchorElem.getBoundingClientRect()
  const editorScrollerRect = scrollerElem.getBoundingClientRect()
  const indentfromSidebar = sideContainerRect?.width
    ? -sideContainerRect.width + DEFAULT_SIDEBAR_WIDTH
    : DEFAULT_SIDEBAR_WIDTH
  let top = targetRect.top + targetRect.height - floatingElemRect.height * 2 + paddingTop
  let left = targetRect.left + HORIZONTAL_OFFSET + targetRect.width - floatingElemRect.width
  if (window.innerHeight - top - floatingElemRect.height < 165) {
    top -= floatingElemRect.height + targetRect.height + 15
  }

  if (left < editorScrollerRect.left) {
    left = left + editorScrollerRect.left + HORIZONTAL_OFFSET + verticalGap + indentfromSidebar
  }

  top -= anchorElementRect.top
  left -= anchorElementRect.left

  floatingElem.style.opacity = "1"
  floatingElem.style.transform = `translate(${left}px, ${top}px)`
  return { left, top }
}
